import Vue from 'vue';
import { USER, REGISTER, LOGIN, LOGOUT, FORGOT_PASSWORD, RESET_PASSWORD } from '~/consts';

export const state = () => ({
  auth: null,
  token: null,
  isTeacher: false,
  isStudent: false,
  isAdmin: false,
  isLead: false,
  hasLead: false,
  countLead: 0,
  editMode: true,
  get_active_package_loading: false,
  active_package_has_been_taken: false,
  personal_storage_used: 0,
  personal_storage_detail: {},
  account_storage_used: 0,
  account_storage_detail: {},
  account_class_used: 0,
  account_conferences_used: 0,
  account_periode: 0,
  university_news: false,
  university_news_id: null,
  maintenance_message: null,
  personal_package_dropdown: false,
  is_export_report_loading: false,
  is_init_livechat: false,
  is_show_guideline_zoom: false,
  is_show_modal_privacy_policy: false,
  show_dashboard_admin: false,
  show_leader_dashboard: false,
  is_faculty_exists: true,
})

export const mutations = {
  toggleEditMode(state, val) {
    state.editMode = val;
  },
  setToken (state, token) {
    state.token = token;
  },
  clearToken (state) {
    state.token = null;
  },
  setAuth (state, auth) {
    const pt = auth.active_pt;

    state.auth = auth;
    state.isTeacher = !helpers.isEmpty(pt) && pt.type == 'LECTURER';
    state.isStudent = !helpers.isEmpty(pt) && pt.type == 'STUDENT';
    state.isAdmin = !helpers.isEmpty(pt) && pt.type == 'ADMIN';
    state.show_dashboard_admin = !helpers.isEmpty(pt) && pt.type == 'ADMIN';
    state.show_leader_dashboard = !helpers.isEmpty(auth.activeAccount) && auth.activeAccount.isLeader == true;
    state.isLead = pt?pt.isLead: false;
    state.hasLead = pt?pt.hasLead: false;
    state.countLead = pt?pt.countLead: false;
  },
  clearAuth (state) {
    state.auth = null;
  },
  resetState(state) {
    state.auth = null;
    state.token = null;
    state.isTeacher = false;
    state.isStudent = false;
    state.isAdmin = false;
    state.isLead = false;
    state.hasLead = false;
    state.countLead = 0;
    state.show_dashboard_admin = false;
    state.show_leader_dashboard = false;
  },
  setState(state, {key, value}) {
    state[key] = value
  }
}

export const actions = {
  getProfile({ commit }) {
    this.$axios.post(USER.GET_PROFILE).then(({ data }) => {
      if (data !== undefined && data !== null && data.applicationSystem.code == 0) {
        commit('setAuth', data.data);
      }
    })
  },
  login({commit, dispatch}, vm) {
    const cookies = this.$cookies;

    vm.loading = true;

    const user = vm.user;
    const postData = {
      username: user.username,
      app_id: user.app_id,
      email: user.email,
      password: user.password,
      web_reg_id: user.web_reg_id
    };

//    Execute Request
    this.$axios.post(LOGIN, postData).then(({ data }) => {
      let message = data.applicationSystem.message;

      if (data.applicationSystem.code == 0) {
        if (data.data.status == 'ACTIVE') {
          const token = data.data.userToken.token;
  //        Success
          commit('setToken', token);
          cookies.set('token', token, {
            path: '/',
            expires: this.getDateOfTokenExpires(),
          });

          this.$router.push('/setup');
        } else {
          toast.info(data.applicationSystem.message);

          this.$router.push({ path: '/confirm', query: { email: postData.email } });
        }
      } else {
//        Failed
        toast.danger(message)
      }

      vm.loading = false;
    }).catch(() => {
      vm.loading = false;
    });
  },

  logout({ commit, state }) {
    const cookies = this.$cookies;

    this.$axios.post(LOGOUT, {}).then(({ data }) => {
      commit('clearAuth');
      commit('clearToken');
      commit('resetState');
      commit('universities/resetUniversitiesState');
      cookies.remove('token');
      let token_temp = cookies.get('token_temp');

      if (!helpers.isEmpty(token_temp)) {
        commit('setToken', token_temp);
        cookies.set('token', token_temp);
        cookies.remove('token_temp');
      }

      window.location.href = '/login';
    }).catch(() => {
      commit('clearAuth');
      commit('clearToken');
      commit('resetState');
      commit('universities/resetUniversitiesState');
      cookies.remove('token');

      window.location.href = '/login';
    });
  },

  register({ commit }, vm) {
    const user = vm.user;
    const postData = {
      name: user.name,
      email: user.email,
      password: user.password,
      password_confirmation: user.password_confirmation
    };

    vm.loading = true;

    this.$axios.post(REGISTER, postData).then(({ data }) => {
      let message = data.applicationSystem.message;


//      Success Register
      if (data.applicationSystem.code == 0) {
        toast.info(message);
        vm.$router.push({ path: '/confirm' , query: { email: postData.email } });
      } else {
        toast.danger(message)
      }

      vm.loading = false;
    }).catch(() => {
      vm.loading = false;
    });
  },

  forgotPassword({ commit }, {vm, email}) {
    vm.loading_forgot = true;

    this.$axios.post(FORGOT_PASSWORD, {email})
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          toast.info(data.applicationSystem.message);

          if (!helpers.isEmpty(vm['resend_countdown'])) {
            vm.resend_countdown = 60;
            setInterval(() => {
              vm.resend_countdown == vm.resend_countdown--;

              if (vm.resend_countdown == 0) {
                clearInterval();
              }
            }, 1000)
          }

          this.$router.push({ path: '/reset', query: { email } });
        } else {
          toast.danger(data.applicationSystem.message);
        }

        vm.loading_forgot = false;
      }).catch(() => {
        vm.loading_forgot = false;
      })
  },

  resetPassword({ commit }, {vm, reset_data}) {
    vm.loading = true;
    const postData = {
      email: reset_data.email,
      resetCode: reset_data.code,
      newPassword: reset_data.new_password,
    }

    this.$axios.post(RESET_PASSWORD, postData)
      .then(({ data }) => {

        if (data.applicationSystem.code == 0) {
          toast.default(data.applicationSystem.message);

          this.$router.push('/login');
        } else {
          toast.danger(data.applicationSystem.message);
        }

        vm.loading = false;
      }).catch(() => {
        vm.loading = false;
      })
  },

  getStorageUsed({ commit , callback }, period = null) {
    commit('setState', { key: 'get_active_package_loading', value: true });
    this.$axios.post(`${USER.GET_ACTIVE_PACKAGE}?period=${period ?? ""}`)
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          commit('setState', {
            key: 'personal_storage_used', value: data.data.storage,
          })

          commit('setState', {
            key: 'account_storage_used', value: data.data.accountStorage,
          })

          commit('setState', {
            key: 'account_class_used', value: data.data.accountClassUsed,
          })

          commit('setState', {
            key: 'account_conferences_used', value: data.data.accountConferencesUsed,
          })

          commit('setState', {
            key: 'personal_storage_detail', value: data.data.storageDetail,
          })
          commit('setState', {
            key: 'account_storage_detail', value: data.data.accountStorageDetail,
          })

          commit('setState', {
            key: 'account_periode', value: data.data.accountPeriode,
          })

          setTimeout(() => {
            commit('setState', { key: 'get_active_package_loading', value: false });
            commit('setState', { key: 'active_package_has_been_taken', value: true });
          }, 1000);
        }
      }).then(() => {
        if (typeof callback =='function') {
          callback()
        }
      }).catch(() => {
        commit('setState', { key: 'get_active_package_loading', value: false });
        commit('setState', { key: 'active_package_has_been_taken', value: false });
      })
  },
  dropdownPersonalPackage({ commit }, { value } ) {
    commit('setState', { key: 'personal_package_dropdown', value: value })
  },
  toogleGuidelineZoom({ commit }, { value }) {
    commit('setState', { key: 'is_show_guideline_zoom', value: value })
  },
  approvePrivacyPolicy({ commit }, { value }) {
    commit('setState', { key: 'is_show_modal_privacy_policy', value: value })
  }
}
